import React, { useState, useEffect } from 'react';
import DataProvider from '../../Data/DataProvider';
import SearchBar from '../../SearchBar/SearchBar';
import Carousel from '../../Carousel/Carousel';
import "./PodcastGuestSearch.css";

export default function PodcastGuestSearch() {
  const [searchTerm, setSearchTerm] = useState('');
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <DataProvider>
      {({
        experts,
        loading,
        error,
        activeCategory,
        setActiveCategory,
        categories,
        handleNext,
        handlePrev,
        searchQuery,
        setSearchQuery,
        handleSearch,
        isSearchMode,
        resetSearch,
        displayedExperts = experts,
        loadMore = handleNext,
        hasMore = true
      }) => {
        const params = new URLSearchParams(window.location.search);
        const GLOBE_ICON_URL =
          params.get('globe_icon_url') ||
          'https://qwotedstg.wpenginepowered.com/wp-content/uploads/2025/04/globe-1.svg';

        const visibleCategories = categories.map((cat) => ({
          name: cat.label,
          icon: cat.icon || GLOBE_ICON_URL,
        }));

        const handleTagSearch = (tagString) => {
          setSearchQuery(tagString);
          handleSearch(tagString);
        };

        const activeLabel =
          categories.find((c) => c.key === activeCategory)?.label || "All";

        // Only preload on initial "All" (and not during searches)
        const isAll = String(activeCategory || "all").toLowerCase() === "all";
        const enablePreloads = isAll && !isSearchMode;

        // ✅ Make onSearchSubmit pass the term
        const onSearchSubmit = (term) => {
          const q = typeof term === 'string' ? term : searchQuery;
          setSearchQuery(q);
          handleSearch(q); // DataProvider will run semantic search (see next section)
        };

        return (
          <>
            {isMobile ? (
              <>
                <Carousel
                  items={displayedExperts}
                  loading={loading}
                  error={error}
                  loadMore={loadMore}
                  hasMore={hasMore}
                  onNext={handleNext}
                  onPrev={handlePrev}
                  onTagClick={handleTagSearch}
                  enablePreloads={enablePreloads}
                />
                <div className='mobile-space' />
                <SearchBar
                  categories={visibleCategories}
                  activeCategory={activeLabel}
                  onChangeCategory={(label) => {
                    const found = categories.find((c) => c.label === label);
                    if (found) setActiveCategory(found.key);
                  }}
                  searchTerm={searchQuery}
                  onSearchChange={setSearchQuery}
                  onSearchSubmit={onSearchSubmit}
                  isSearchMode={isSearchMode}
                  onReset={resetSearch}
                />
              </>
            ) : (
              <>
                <SearchBar
                  categories={visibleCategories}
                  activeCategory={activeLabel}
                  onChangeCategory={(label) => {
                    const found = categories.find((c) => c.label === label);
                    if (found) setActiveCategory(found.key);
                  }}
                  searchTerm={searchQuery}
                  onSearchChange={setSearchQuery}
                  onSearchSubmit={onSearchSubmit}
                  isSearchMode={isSearchMode}
                  onReset={resetSearch}
                />
                <Carousel
                  items={displayedExperts}
                  loading={loading}
                  error={error}
                  loadMore={loadMore}
                  hasMore={hasMore}
                  onNext={handleNext}
                  onPrev={handlePrev}
                  onTagClick={handleTagSearch}
                  enablePreloads={enablePreloads}
                />
              </>
            )}
          </>
        );
      }}
    </DataProvider>
  );
}
